import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d7bc6018"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "approveBtnGroup" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("审批通过")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("驳回")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "tips"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "是否驳回此份劳动合同", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("驳回")

import { ref, reactive, onActivated} from 'vue'
import ContractTemplate from './contractTemplate/ContractTemplate.vue'
import ServiceTemplate from './contractTemplate/ServiceTemplate.vue'
import InternshipTemplate from './contractTemplate/InternshipTemplate.vue'
import { useRoute } from 'vue-router'
import Api from '@/http/modules/index'
import { ElMessage, ElMessageBox } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  // 根据id获取合同
  'GET/labor_contracts/get/{id}': getContractsInfoApi,
  // 驳回
  'PATCH/labor_contracts/home_page/reject': rejectApi,
  // 审批通过
  'POST/labor_contracts/home_page/approving': approvingApi,

} = Api
const route = useRoute()
const isLoadContract = ref<boolean>(false)

// 如果有id,则展示模板
const isShowApprove = ref<boolean>(false)
let contractInfoObj = reactive({})
onActivated(() => {
  if(route.params.id){
    getContractsInfoApi({ id: parseInt(route.params.id as string)}).then((rep) => {
      if( rep.category === 'Termination'){
        ElMessage.warning('此合同已终止,无需审批')
        return
      }
      Object.assign(contractInfoObj, rep)
      isShowApprove.value = true
    })
  } else {
    isShowApprove.value = false
  }
})


// 审批通过
const resovleHandle = () => {
  ElMessageBox.confirm(
    '是否确认此份劳动合同',
    '提示',
    {
      confirmButtonText: '审批通过',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
    isLoadContract.value = true
    return approvingApi({id: parseInt(route.params.id as string)}, {contentType: 'formData'})
  }).then(() => {
    ElMessage.success('审批成功')
    isShowApprove.value = false
  }).catch((err) => {
    if(err === 'cancel'){ ElMessage.info('已取消') }
  }).finally(() => {
    isLoadContract.value = false
  })
}

// 审批驳回
const isShowCancel = ref<boolean>(false)
const cancelReject = () => {
  isShowCancel.value = false
  ElMessage.info('已取消驳回')
}
const rejectHandle = () => {
  isLoadContract.value = true
  rejectApi({ id: parseInt(route.params.id as string)}, {contentType: 'formData'}).then(() => {
    ElMessage.success('已驳回')
    isShowApprove.value = false
  }).finally(() => {
    isShowCancel.value = false
    isLoadContract.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({'contractContent': isShowApprove.value})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !isShowApprove.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (resovleHandle()))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        type: "danger",
        disabled: !isShowApprove.value,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (isShowCancel.value = true))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    (isShowApprove.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_unref(contractInfoObj).category === 'FullTime')
            ? (_openBlock(), _createBlock(ContractTemplate, {
                key: 0,
                contractInfoObj: _unref(contractInfoObj)
              }, null, 8, ["contractInfoObj"]))
            : _createCommentVNode("", true),
          (_unref(contractInfoObj).category === 'PartTime')
            ? (_openBlock(), _createBlock(ServiceTemplate, {
                key: 1,
                contractInfoObj: _unref(contractInfoObj)
              }, null, 8, ["contractInfoObj"]))
            : _createCommentVNode("", true),
          (_unref(contractInfoObj).category === 'Internship')
            ? (_openBlock(), _createBlock(InternshipTemplate, {
                key: 2,
                contractInfoObj: _unref(contractInfoObj)
              }, null, 8, ["contractInfoObj"]))
            : _createCommentVNode("", true)
        ])), [
          [_directive_loading, isLoadContract.value]
        ])
      : _createCommentVNode("", true),
    (!isShowApprove.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 暂无需审批合同 "))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      title: "提示",
      modelValue: isShowCancel.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isShowCancel).value = $event)),
      width: "400px",
      top: "40vh"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (cancelReject()))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (rejectHandle())),
          type: "danger"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}
}

})